import { render, staticRenderFns } from "./tasklst.vue?vue&type=template&id=3b2cdc78&scoped=true&"
import script from "./tasklst.vue?vue&type=script&lang=js&"
export * from "./tasklst.vue?vue&type=script&lang=js&"
import style0 from "./tasklst.vue?vue&type=style&index=0&id=3b2cdc78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2cdc78",
  null
  
)

export default component.exports